import type { FunctionComponent } from 'react';
import { CopyToClipboard as ReactCopyToClipboard } from 'react-copy-to-clipboard';
import Icon, { icons } from '../Icon';
import styles from './CopyToClipboard.module.less';
import { useCopyToClipboard } from '../../../hooks/useCopyToClipboard';

type Props = {
  // Text to copy to clipboard
  text: string;
  // On copy callback
  onCopy?: () => void;
  // Show the copy icon, defaults to true
  showCopyIcon?: boolean;
};

/**
 * Renders children with an optional copy icon. On click will copy provided text to clipboard.
 *
 * @example
 * <CopyToClipboard text="Hello World" onCopy={() => console.log('Copied!')}>Copy Hello World</CopyToClipboard>
 */
const CopyToClipboard: FunctionComponent<Props> = ({ text, onCopy, showCopyIcon = true, children }) => {
  //  Handle setting the text of the "copy" button.
  const [isCopied, setIsCopied] = useCopyToClipboard(onCopy);

  return (
    <ReactCopyToClipboard text={text} onCopy={() => setIsCopied(true)}>
      <div className={styles.inner}>
        {children}
        {showCopyIcon && <Icon icon={isCopied ? icons.check : icons.cloneO} testId="copy-to-clipboard-icon" />}
      </div>
    </ReactCopyToClipboard>
  );
};

export default CopyToClipboard;
